/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsPageAccordion = {
  init: function() {
  	const desktop = window.matchMedia('only screen and (min-width: 768px)').matches;
  	const anchors = $('.page-accordion').attr('data-anchors') === 'true';
  	const scrollingTabs = $('.page-tabs').hasClass('scrolling-tabs');
    let $pageTab, $pageHeading, useAnchor = false;
  
    let sectionLayout = function() {
      let oldSection = $('.jsPageAccordion');
      let sections, content, j, last, section, id;

      try {
        //Adding a new element for the existing page accordion section seems to solve Shopify's error in the theme editor: HTML error found
        section = $('<div></div>');
        
        id = oldSection.attr('id');
        oldSection.removeAttr('id');
        section.attr('id', id);
        
        section.attr('class', oldSection.attr('class'));
        section.html(oldSection.html());
        section.insertAfter(oldSection);
        
        content = section.find('.page-accordion dd .content');
        
        oldSection.remove();
        
        sections = $('.shopify-section');
        last = sections.length - 1;
        
        sections.each(function(i){
          if($(this).is(section)) {
            j = i;
            return false;
          }
        });

        content.each(function(i){
          let count = parseInt($(this).attr('data-count')) || 0;

          for(let k = 0; k < count; k++) {
            if(j < last) {
              j++;
            } else {
              return false;
            };

            if(sections.eq(j) && (!sections.eq(j).id || sections.eq(j).id.indexOf('footer') < 0)) {
              //sections.eq(j).attr('class', '').attr('id', '').html();
              content.eq(i).append(sections.eq(j));
            } else {
              return false;
            }
          }
        });

      } catch(error) {
          console.log(error); 
      }
    }
    
    let goToAnchor = function() {
      let id = location.hash.replace('#', '');
      let tab, content;
      
      if(anchors && id) {
        tab = $('.page-tabs > .tab > .accordion__button[data-anchor="' + id + '"]');
        
        if(tab) {
          useAnchor = true; 
          tab.trigger('activate');
          content = $('#' + id );
          
              if(desktop) {
                setTimeout(function() {
                	window.scrollTo(0, $('.page-tabs').offset().top);
                }, 300);
              } else if(content) {
                  setTimeout(function() {
                      window.scrollTo(0, content.parent().prev().offset().top);
                  }, 600);
              }
          return;
        }
      }
      
      if(desktop) {
      	$pageTab.eq(0).trigger('activate');
      }
    }
  
    let scrollFull = function () {
      let tabs = $('.page-tabs');
      let aTop = tabs.height() + tabs.prev().height() + tabs.prev().offset().top + 100;
      let update = function(){
        
        if($(this).scrollTop()>= aTop){
          tabs.addClass('fixed');
        } else {
          tabs.removeClass('fixed');
        }
      }
      
      if(scrollingTabs && tabs.css('display') !== 'none') {
        update();
        $(window).on('scroll', update);
      }
    }
    
    sectionLayout();
  
    $pageTab = $('.page-tabs > .tab > .accordion__button');
    $pageHeading = $('.page-accordion > dt > button');

    $('.page-accordion > dd').attr('aria-hidden',true);
//     $('.page-accordion > dt').addClass('drew');

    $pageTab.attr('aria-expanded',false);
    $pageHeading.attr('aria-expanded',false);
  

    $pageTab.on('click activate',function(){
      const tab = $(this);
      const pageTitle = $('.page-accordion > dt > button[aria-controls="' + $(this).attr('aria-controls') + '"]');
      const pageIcons = pageTitle.find('.icon');
      const state = true;
      const anchor = (tab.attr('data-anchor') || '').trim();
      let top;
      
      $pageTab.each(function(i) {
      	$(this).attr('aria-expanded',false);
      });
      
      $pageHeading.each(function(i) {
      	$(this).parent().next().slideUp(0, function(){
          $(this).find('.icon').removeClass('icon--active');
        });
      });
      
      tab.attr('aria-expanded',state);
      pageTitle.attr('aria-expanded',state);
      
      if(anchors && anchor && useAnchor) {
        location.hash = '#' + anchor;
        
        if(desktop) {
          top = $('.page-tabs').prev().offset().top - parseInt($('.page-tabs').css('top') || 0);

          if(top < $(document).scrollTop()) {
            window.scrollTo(0, top);
          }
        }
      } else {
        useAnchor = true; 
      }
      
      pageTitle.parent().next().slideDown(0, function(){
        pageIcons.addClass('icon--active');
      });
      
      $(this).parent().next().attr('aria-hidden',!state);
      
      return false;
    });

    $pageHeading.on('click activate',function(){
		
      const tab = $('.page-tabs > .tab > .accordion__button[aria-controls="' + $(this).attr('aria-controls') + '"]');
      const pageTitle = $(this);
      const pageIcons = pageTitle.find('.icon');
      const anchor = (tab.attr('data-anchor') || '').trim();

      let state = pageTitle.attr('aria-expanded') === 'false' ? true : false;
      let open;
      
      $pageHeading.each(function(i) {
        if(!$(this).is(pageTitle)) {
          if($(this).attr('aria-expanded') !== 'false') {
            open = true;
          }
          
          $(this).attr('aria-expanded',false).parent().next().slideUp(function(){
            $(this).find('.icon').removeClass('icon--active');
          });
        }
      });
      
      tab.attr('aria-expanded',state);
      pageTitle.attr('aria-expanded',state);
      
      if(anchors && anchor) {
        location.hash = '#' + anchor;
      }
            
      pageTitle.parent().next().slideToggle(200, function(){
        if(state) {
          pageIcons.addClass('icon--active');
        } else {
          pageIcons.removeClass('icon--active');
        }
        
        window.scrollTo(0, pageTitle.offset().top);
        
        if(open) {
          setTimeout(function() {
          	window.scrollTo(0, pageTitle.offset().top);
          }, 200);
        }
      });
      
      $(this).parent().next().attr('aria-hidden',!state);
      
      return false;
    });

    $pageHeading.on('keydown',function(event){
      let keyCode = event.keyCode || e.which;
      if (keyCode === 13){
        $(this).trigger('activate');
      }
    });

  	goToAnchor();
  	scrollFull();
  },
  unload: function() {
//     $(window).off('scroll'); //only use this if you are certain the event is not used elsewhere
    $('.page-tabs > .tab > .accordion__button').off('click activate');
    $('.page-accordion > dt > button').off('click activate');
    $('.page-accordion > dt > button').off('keydown');
  }
}
/******/ })()
;